import React, { useEffect, useMemo, useState } from "react";
import NumberFormat from "react-number-format";
import {NFTItemIcon} from "../Icons/NFTItemIcon";
import {
  baseCurrencyCode,
  validateDecimalSeparator,
  prefixCcySymbol,
  suffixCcySymbol,
} from "../../utils/Currency";
import { roundNumber } from "../../services/app";
import { useWindowSize } from "../../hook/useWindowSize";
import { useApp } from "../../contexts";
import { ITEM_POSITION_ENUMS } from "../../constants";
import { getPropByLanguage } from "../../utils/Language";
import { useNavigate } from "react-router-dom";
import IconPicture from "../Icons/IconPicture";
import IconMotion from "../Icons/IconMotion";
import VideoJS from "../../components/video";
import LoopVideoPlayer from "../video/LoopVideo";
import LazyVideoItem from "../video/LazyVideoItem";

function Item(props) {
  const size = useWindowSize();
  const isMobile = size.width < 1024 ? true : false;
  const isMobiles = size.width < 768 ? true : false;
  const { T, user, language, convertToLocalCurrency,formatLocalCurrency,
    getCurrency } = useApp();
  const { itemData, categoryTypes, isHome, rankOptions } = props;
  const [randomClass, setRandomClass] = useState("");
  const [price, setPrice] = useState(0);
  const [breedTranslate, setBreedTranslate] = useState(itemData?.breed);
  const [rank, setRank] = useState('');
  const navigate = useNavigate();
  const handleParentClick = (id) => {
    navigate(`/earner-detail/${id}`);
  };
  const [videoUrl, setVideoUrl] = useState('');
  const itemUrl = useMemo(() => {
    if (itemData?.cloudinaryInfo) {
      return itemData?.img.replace("/f_png/", "/f_png/w_400,c_crop/");
    }
    return itemData?.img;
    
  }, [itemData]);

  
  useEffect(() => {
    const arr = Array.from({ length: 7 }, (_, i) => i + 1);
    const random = itemData?.id % 7;
    setRandomClass(`suzu-card-image-${arr[random]}`);
    
  }, []);

  useEffect(() => {
    if (categoryTypes && categoryTypes.length) {
      const category = categoryTypes.find(item => item.id == itemData?.nft_type_category_id)
      if (category) {
        setBreedTranslate(category.nameTranslate[getPropByLanguage(language)] || category.nameTranslate['english'])
        const dogLevels = category?.dogLevel;
        if (dogLevels?.length > 0) {
          const dogLevelsSelected = dogLevels?.find((lvl) => lvl.rankCode == itemData?.rank_code)
          setRank(dogLevelsSelected?.rankTranslate[getPropByLanguage(language)] || '');
        }
      }else{
        setBreedTranslate(itemData?.breed)
      }
    }
  }, [categoryTypes, language, itemData]);  
  useEffect(() => {
    if (rankOptions && rankOptions.length && itemData) {
      const dogLevelsSelected = rankOptions?.find((lvl) => lvl.rankCode == itemData?.rank_code)
        setRank(
          dogLevelsSelected?.rankNameTranslate[getPropByLanguage(language)] || ""
        );
    }
  }, [rankOptions, language, itemData]);

  useEffect(() => {
    if (itemData) {
      setPrice(convertToLocalCurrency(
        itemData.price,
        itemData.ccy,
        getCurrency()
      ))
      
    }
  }, [itemData])
  const handleMouseEnter = () => {
    if (!videoUrl && itemData?.tag_nft_type == 'motion') {
      setVideoUrl(itemData?.long_video_url)
    }
  }
  const handleMouseLeave = () => {
    setVideoUrl('');
  }

  return (
    <>
      {(!isMobile || !isHome) ? (
        <div
          className={`w-auto item-boxs suzu-card cursor-pointer`}
          onClick={() => handleParentClick(itemData?.id)}
          onMouseEnter={() => handleMouseEnter()}
          onMouseLeave={handleMouseLeave}
        >
          <div className="rounded-t-[12px] lg:rounded-t-[10px] xls:rounded-t-[13px] flex items-center justify-center relative">
            <div
              className={`aspect-[246/246] w-full relative rounded-t-[12px] lg:rounded-t-[10px] mb-[15px] lg:mb-[20px] xls:rounded-t-[13px] suzu-earner-img bg-[#F7F7F7] ${randomClass}
              ${
                itemData?.purchase_source == "shopify"
                  ? " overflow-hidden"
                  : ""
              }`}
            >
              <div className="w-full relative h-full suzu-earner-img-wrap" >
                {
                  isMobiles ? <>
                    {
                      itemData?.tag_nft_type == 'motion' ? 
                      <LazyVideoItem source={itemData?.long_video_url} startTime={0} endTime={5} image={itemUrl} /> : 
                      <img
                        src={itemUrl}
                        className={`w-full h-full object-cover`}
                        alt=""
                      />
                    }
                  </> : <>
                    {
                      videoUrl ? <>
                        <LoopVideoPlayer source={videoUrl} startTime={0} endTime={5} />
                      </> : <img
                        src={itemUrl}
                        className={`w-full h-full object-cover`}
                        alt=""
                      />
                    }
                  </>
                }
                {(itemData?.hasSub == true || itemData?.is_free == 1 || itemData?.tag_nft_type) ? (
                  <div className="absolute left-[13px] top-[16px] flex justify-start space-x-2  z-[9]">
                    {itemData?.tag_nft_type == 'photo' ? <div className="item-tag item-picture !relative !top-0 !left-0">
                        <IconPicture /><span>{T('Photo')}</span>
                    </div>: <></>}
                    {itemData?.tag_nft_type == 'motion' ? <div className="item-tag item-motion !relative !top-0 !left-0">
                        <IconMotion /> <span>{T('Motion')}</span>
                    </div>: <></>}
                    {itemData?.hasSub == true && <div className="flex justify-start item-has-sub tag-boxshadow text-[10px] bg-[#F3850F] rounded-[100px] items-center text-white font-[500]  px-3 py-[5px]">
                      <svg
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1577_23718)">
                          <path
                            d="M4.20363 0.65054L4.97029 2.92041L7.36576 2.94814C7.57189 2.95054 7.65723 3.21321 7.49189 3.33614L5.57003 4.76654L6.28389 7.05347C6.34523 7.25027 6.12203 7.41241 5.95376 7.29321L3.99963 5.90734L2.04523 7.29294C1.87723 7.41214 1.65376 7.24974 1.71509 7.05321L2.42896 4.76627L0.507092 3.33587C0.341759 3.21294 0.427092 2.95027 0.633226 2.94787L3.02869 2.92014L3.79536 0.650273C3.86149 0.455073 4.13776 0.455073 4.20363 0.65054Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1577_23718">
                            <rect width="8" height="8" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <div>{T("Art Plus")}</div>
                    </div>}
                    {itemData?.is_free == 1 && <div className="flex justify-start item-has-sub tag-boxshadow text-[10px] space-x-1 bg-[#F86838] rounded-[100px] text-white font-[500] px-3 py-[5px]">
                      <svg className="w-[14px] h-[14px]" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.11328 5.94043C5.34375 6.1709 5.71485 6.1709 5.94141 5.94043C6.16797 5.70996 6.17188 5.33887 5.94141 5.1123L4.28516 3.45605C4.05469 3.22559 3.6836 3.22559 3.45703 3.45605C3.23047 3.68652 3.22657 4.05762 3.45703 4.28418L5.11328 5.94043Z" fill="white"/>
                        <path d="M1.08594 11.0859H3.46875C3.79297 11.0859 4.05469 10.8242 4.05469 10.5C4.05469 10.1758 3.79297 9.91406 3.46875 9.91406H1.08594C0.761719 9.91406 0.5 10.1758 0.5 10.5C0.5 10.8242 0.761719 11.0859 1.08594 11.0859Z" fill="white"/>
                        <path d="M19.9141 9.91406H17.5312C17.207 9.91406 16.9453 10.1758 16.9453 10.5C16.9453 10.8242 17.207 11.0859 17.5312 11.0859H19.9141C20.2383 11.0859 20.5 10.8242 20.5 10.5C20.5 10.1758 20.2383 9.91406 19.9141 9.91406Z" fill="white"/>
                        <path d="M17.542 3.45605C17.3115 3.22559 16.9404 3.22559 16.7139 3.45605L15.0576 5.1123C14.8271 5.34277 14.8271 5.71387 15.0576 5.94043C15.2881 6.16699 15.6592 6.1709 15.8857 5.94043L17.542 4.28418C17.7725 4.05371 17.7725 3.68652 17.542 3.45605Z" fill="white"/>
                        <path d="M11.0859 3.46875V1.08594C11.0859 0.761719 10.8242 0.5 10.5 0.5C10.1758 0.5 9.91406 0.761719 9.91406 1.08594V3.46875C9.91406 3.79297 10.1758 4.05469 10.5 4.05469C10.8242 4.05469 11.0859 3.79297 11.0859 3.46875Z" fill="white"/>
                        <path d="M5.39026 9.16313C4.93323 11.0381 5.46058 12.9366 6.80823 14.2608C7.2887 14.7413 7.56995 15.4952 7.56995 16.2686V16.3975C7.56995 16.7256 7.82776 16.9834 8.15589 16.9834H12.8434C13.1715 16.9834 13.4293 16.7256 13.4293 16.3975V16.2686C13.4293 15.5069 13.7223 14.7295 14.2379 14.2256C15.2223 13.2295 15.7731 11.9053 15.7731 10.4991C15.7731 8.88188 15.0465 7.37016 13.7809 6.36235C12.5035 5.35453 10.8512 4.99125 9.23401 5.37797C7.35901 5.81157 5.84729 7.29985 5.39026 9.16313ZM10.4996 7.56938C10.8239 7.56938 11.0856 7.8311 11.0856 8.15532C11.0856 8.47953 10.8239 8.74125 10.4996 8.74125C9.61683 8.74125 8.97229 9.32719 8.80433 10.0069C8.7262 10.3155 8.41761 10.5108 8.09339 10.4366C7.78089 10.3584 7.58948 10.042 7.66761 9.72563C7.95667 8.55375 9.05823 7.56938 10.4996 7.56938Z" fill="white"/>
                        <path d="M11.0859 20.5C12.0547 20.5 12.8438 19.7109 12.8438 18.7422V18.1562H8.15625V18.7422C8.15625 19.7109 8.94531 20.5 9.91406 20.5H11.0859Z" fill="white"/>
                      </svg>
                      <div>{T("Free")}</div>
                    </div>}
                  </div>
                ) : (
                  ""
                )}
                {itemData.token_id_onchain ? <div className="bottom-[10px]  z-[9] left-[10px] lg:bottom-[10px] lg:left-[10px] absolute"><NFTItemIcon className="" /></div>: <></>}
              </div>
            </div>
          </div>
          <div className="suzu-card-body">
            <div
              className={`w-full h-full px-[14px] lg:px-[12px] xls:px-[14px] pt-[0] pb-[16px]`}
            >
              <div className="flex items-center justify-between mb-[6px] lg:mb-[5px]">
                <p className="leading-[18px] lg:leading-[22px] text-[14px] xls:text-[16px] text-[#131516] font-[600] truncate">
                  {itemData?.name || breedTranslate}
                </p>
                <span
                  className={`rounded-[30px] px-[6px] text-[12px]/[18px]  xs:px-[10px] lg:px-[19px] py-[2px] 
                  flex items-center justify-center lg:text-[10px]/[21px] xls:text-[13px]/[24px]
                  ${
                    itemData?.position == ITEM_POSITION_ENUMS.ITEM_POSITION_APP
                      ? "tag-inapp"
                      : "tag-inmarket"
                  }`}
                >
                  {itemData?.position == ITEM_POSITION_ENUMS.ITEM_POSITION_APP
                    ? T("In app")
                    : T("In market")}
                </span>
              </div>
              <div className="flex items-end justify-between">
                <div className="flex flex-col gap-[5px] truncate">
                  <span className="text-[12px] lg:text-[12px] xls:text-[15px] text-[#616161] whitespace-nowrap">
                    #{itemData?.id}
                  </span>
                  {itemData?.item_type == 9 && (
                    <span className="text-[12px] lg:text-[12px] xls:text-[15px] text-[#616161] leading-[15px] whitespace-nowrap  truncate">
                      {rank ? `Rank: ${rank}` : ""}
                    </span>
                  )}
                </div>
                <NumberFormat
                  className="text-[#000] text-[14px] lg:text-[16px]/[16px] xls:text-[20px]/[20px] font-[600] flex-2"
                  value={formatLocalCurrency(roundNumber(price, 2))}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={prefixCcySymbol(true, getCurrency())}
                  suffix={suffixCcySymbol(true, getCurrency())}
                  decimalScale={validateDecimalSeparator(
                    baseCurrencyCode(true, getCurrency())
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`flex justify-start items-center gap-[13px] py-[5px] suzu_item_mb`}
          onClick={() => handleParentClick(itemData?.id)}
        >
          <div className="overflow-hidden w-[37px] h-[37px] bg-[#D9D9D9] rounded-full">
            <img
              src={itemUrl}
              className="rounded-full object-contain  w-full h-full"
              alt=""
            />
          </div>
          <div className="flex flex-col items-start justify-start flex-1">
            <p className="leading-[19px] text-[16px] text-[#131516] font-[600] mb-[4px] flex">
              {itemData?.name || breedTranslate}
              {itemData?.hasSub == true ? (
                <div className="flex ml-[10px] justify-center text-[7px] bg-[#E9A033] rounded-[100px] 
                  items-center text-white font-[500] px-2 py-[2px] max-h-[24px] truncate">
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1577_23718)">
                      <path
                        d="M4.20363 0.65054L4.97029 2.92041L7.36576 2.94814C7.57189 2.95054 7.65723 3.21321 7.49189 3.33614L5.57003 4.76654L6.28389 7.05347C6.34523 7.25027 6.12203 7.41241 5.95376 7.29321L3.99963 5.90734L2.04523 7.29294C1.87723 7.41214 1.65376 7.24974 1.71509 7.05321L2.42896 4.76627L0.507092 3.33587C0.341759 3.21294 0.427092 2.95027 0.633226 2.94787L3.02869 2.92014L3.79536 0.650273C3.86149 0.455073 4.13776 0.455073 4.20363 0.65054Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1577_23718">
                        <rect width="8" height="8" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <div className="truncate">
                    {T("Art Plus")}
                  </div>
                </div>
              ) : (
                ""
              )}
            </p>
            <span className="text-[12px] lg:text-[15px] text-[#616161] whitespace-nowrap">
              #{itemData?.id}
            </span>
            {itemData?.item_type == "9" && (
              <span className="text-[12px] text-[#616161] font-[400] leading-[15px] whitespace-nowrap truncate">
                {rank ? `Rank: ${rank}` : ""}
              </span>
            )}
          </div>
          <div className="flex flex-col items-end">
            <NumberFormat
              className="text-[#272729] text-[16px] font-[600] tracking-[0.2px] mb-[6px]"
              value={formatLocalCurrency(roundNumber(price, 2))}
              displayType={"text"}
              thousandSeparator={true}
              prefix={prefixCcySymbol(true, getCurrency())}
              suffix={suffixCcySymbol(true, getCurrency())}
              decimalScale={validateDecimalSeparator(
                baseCurrencyCode(true, getCurrency())
              )}
            />
            <span
              className={`rounded-[30px] px-[19px] py-[4px] flex items-center justify-center text-[12px]/[12px]
          ${
            itemData?.position == ITEM_POSITION_ENUMS.ITEM_POSITION_APP
              ? "tag-inapp"
              : "tag-inmarket"
          }`}
            >
              {itemData?.position == ITEM_POSITION_ENUMS.ITEM_POSITION_APP
                ? T("In app")
                : T("In market")}
            </span>
          </div>
        </div>
      )}
    </>
  );
}

export default Item;
